"use strict";

var _TagManager = _interopRequireDefault(require("./TagManager"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
module.exports = _TagManager.default;